import ebikeImage from "../Assets/084c6378-c9bc-4f72-ad9a-39a8303499c7.jpg";
import ebikeImage2 from "../assets2/IMG_20240528_162807.jpg"
import damenImg from "../Assets/WhatsApp Image 2025-02-12 at 14.26.36.jpeg";
import ttImg from "../Assets/WhatsApp Image 2025-02-12 at 14.26.36 (2).jpeg";
import NordicWalking from "../Assets/WhatsApp Image 2025-02-12 at 14.26.36 (1).jpeg";
import herrenImg from "../Assets/WhatsApp Image 2025-02-19 at 12.53.24.jpeg";
import SkateBoard from "../Assets/80c6a924-3c2a-48e2-9407-69d289769e73.jpg";
import ttImg2 from "../assets2/IMG_20240322_153737.jpg";
import SkateBoard2 from "../assets2/IMG_20240505_122550.jpg"
import SkateBoard3 from "../assets2/IMG_20240505_122542.jpg"
import SkateBoard4 from "../assets2/4ef32f61-818a-4bdb-ad3d-d2e2e83a2aaf.jpg"
const sportgruppenData = [
  {
    id: "ebike-gruppe",
    title: "E-Bike-Gruppe",
    description: "Beliebte Ausflüge in die Umgebung – auch für Radfahrer ohne E-Bike.",
    image: ebikeImage2,
    ebikeImage2,
    //
    schedule: [
      "jeden Dienstag um 15:00 Uhr von April bis Oktober",
      "einmal monatlich an einem Samstag",
      "Saisonstart: April"
    ],
    details:
      "Unsere E-Bike-Gruppe erfreut sich großer Beliebtheit. Dienstags sowie einmal monatlich an einem Samstag unternehmen wir Ausflüge in die Umgebung. Auch Radfahrer ohne elektrische Unterstützung sind herzlich eingeladen. Treffpunkt im Kurpark am Quellpavillon.",
    gallery: [
      ebikeImage, 
      ebikeImage2
    ],
  },
  {
    id: "gymnastik-gruppe",
    title: "Damen Gymnastik",
    description: "Mittwochs treffen sich die Damen für ein vielseitiges Training mit lizenzierten Trainerinnen.",
    image: damenImg,
    schedule: [
      "jeden Mittwoch ab 19 Uhr"
    ],
    details: "Unser ganzheitliches Training für Damen bietet eine perfekte Kombination aus Bewegung und Austausch. Unter der Anleitung einer Lizenz-Trainerin werden verschiedene Übungen durchgeführt. Im Anschluss bleibt Zeit für ein geselliges Beisammensein. Es sind noch wenige Plätze frei!",
    gallery: [
      damenImg,
      
    ],
  },
  {
    id: "tischtennis-gruppe",
    title: "Tischtennis-Gruppe",
    description: "Training und Wettkampf für alle Altersgruppen – von Kindern bis Erwachsenen.",
    image: ttImg,
    schedule: [
      "Donnerstags: ab 17:30 Uhr (Erwachsene – intensiv oder gesellig)",
      "Freitags: 15:00–16:30 Uhr (Kindertischtennis 8–14 Jahre)",
      "Freitags: ab 18:00 Uhr (Erwachsene – Powerplay)"
    ],
    details: "Unsere Tischtennis-Gruppe bietet Training für alle Altersgruppen. Donnerstags findet das Erwachsenentraining statt – individuell abgestimmt auf sportliche Intensität oder gesellige Spielrunden. Freitags haben Kinder die Möglichkeit, unter Anleitung erfahrener Trainer Tischtennis zu lernen, bevor abends die Erwachsenen zum Powerplay antreten.",
    gallery: [
      ttImg2,
      ttImg
    
    ],
  },
  {
    id: "herren-training",
    title: "Herren-Training",
    description: "Sportliches Training mit Gemeinschaft und geselligem Ausklang.",
    image: herrenImg,
    schedule: [
      "jeden Montag",
      "Seniorengruppe: ab 18:00 Uhr",
      "U70-Gruppe: ab 19:00 Uhr"
    ],
    details: "Montags steht für unsere Herren eine auf die Teilnehmer abgestimmte Trainingseinheit auf dem Plan. Neben dem sportlichen Aspekt wird auch viel Wert auf Gemeinschaft gelegt – sei es bei einem erfrischenden Getränk oder einem Grillabend im Anschluss.",
    gallery: [
      herrenImg
    ],
  },
  {
    id: "nordic-walking",
    title: "Nordic-Walking-Gruppe",
    description: "Gelenkschonendes Ganzkörpertraining mit Naturerlebnis.",
    image: NordicWalking,
    schedule: [
      "jeden Donnerstag",
      "Treffpunkt: 15:30 Uhr (wetterabhängig) am Vereinsheim"
    ],
    details: "Unsere Nordic-Walking-Gruppe bietet ein gelenkschonendes Ganzkörpertraining. Diese Bewegungsform ist ideal, um die Ausdauer zu verbessern, die Muskulatur zu stärken und gleichzeitig die Natur zu genießen.",
    gallery: [
      NordicWalking
    ],
  },
  {
    id: "skateboard-gruppe",
    title: "Skateboard-Gruppe",
    description: "Sicher und mit Spaß auf dem Skateboard unterwegs.",
    image: SkateBoard,
        schedule: [
      "jeden Freitag ab 15 Uhr - 16:30 Uhr (Anfänger)",
      "jeden Freitag ab 16:30 Uhr - 18:00 Uhr (Fortgeschrittene)"
    ],
    details: "Freitags lernen Kinder unter der fachkundigen Anleitung von Elmar Henrich den sicheren Umgang mit Skateboards. Die Kombination aus Bewegung und Spaß macht dieses Angebot zu einem echten Highlight für junge Teilnehmer. Treffpunkt ist am Gemeindezentrum Johannesberg.",
    gallery: [
      SkateBoard,
      SkateBoard2,
      SkateBoard3,
      SkateBoard4
    ],
  },
];

export default sportgruppenData;
